import chat from './chat.vue'
import activityStream from './activityStream.vue'

import { mapActions } from 'vuex'

import roles from '../helpers/userRoles'

const getUserShortInfo = (firstName, lastName) => {
  return `${firstName} ${lastName}`
}

export default {
  name: 'Header',
  components: {
    chat,
    activityStream
  },
  data: function () {
    return {
      roles,
      isAccountOptionsVisible: false,
      isChatVisible: false,
      isActivityViewVisible: false,
      countUnreadedChatMessages: 0,
      countUnreadedActivityMessages: 0,
      pageHeader: ''
    }
  },
  methods: {
    logout () {
      this.logoutUser()
        .then(() => {
          this.$router.push('/login')
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    accountSettings () {
      if (this.isAdAgent) {
        this.$router.push('/ad-agent/personal-information')
      } else {
        this.$router.push('/settings/personal-information')
      }
    },
    toggleAccountOptions () {
      this.isAccountOptionsVisible = !this.isAccountOptionsVisible
    },
    closeAccountOptions () {
      this.isAccountOptionsVisible = false
    },
    toggleChat () {
      this.isChatVisible = !this.isChatVisible
      this.updateChatLastVisitTime(new Date())
      if (this.isChatVisible) {
        this.$eventBus.$emit('onShowChatView')
        this.countUnreadedChatMessages = 0
      }
    },
    closeChat () {
      this.updateChatLastVisitTime(new Date())
      this.isChatVisible = false
    },
    toggleActivityView () {
      this.updateActivityLastVisitTime(new Date())
      this.isActivityViewVisible = !this.isActivityViewVisible
      if (this.isActivityViewVisible) {
        this.$eventBus.$emit('onShowActivityView')
        this.countUnreadedActivityMessages = 0
      }
    },
    closeActivityView () {
      this.updateActivityLastVisitTime(new Date())
      this.isActivityViewVisible = false
    },
    ...mapActions({
      logoutUser: 'LOGOUT_USER',
      toggleSidebar: 'TOGGLE_SIDEBAR',
      toggleFooterBlock: 'TOGGLE_FOOTER_BLOCK',
      connectToWebsocket: 'CONNECT_TO_WS',
      updateChatLastVisitTime: 'UPDATE_CHAT_LAST_VISIT_TIME',
      updateActivityLastVisitTime: 'UPDATE_ACTIVITY_LAST_VISIT_TIME'
    })
  },
  computed: {
    userShortInfo () {
      return this.$store.state.userInfo
        ? getUserShortInfo(
          this.$store.state.userInfo.firstname,
          this.$store.state.userInfo.lastname
        )
        : ''
    },
    roleName () {
      const roles = [
        { name: 'shared.after_printer', id: 'ROLE_AFTER_PRINTER' },
        { name: 'shared.printer', id: 'ROLE_PRINTER' },
        { name: 'shared.designer', id: 'ROLE_DESIGNER' },
        { name: 'shared.manager', id: 'ROLE_MANAGER' },
        { name: 'shared.director', id: 'ROLE_ADMIN' },
        { name: 'shared.master', id: 'ROLE_MASTER' },
        { name: 'shared.accountant', id: 'ROLE_ACCOUNTANT' },
        { name: 'shared.ad_agent', id: 'ROLE_AD_AGENT' }
      ]

      return this.$t(roles.find(x => x.id === this.$store.getters.role).name)
    },
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    },
    isCreateTaskVisible () {
      return (
        this.$store.getters.role === roles.director ||
        this.$store.getters.role === roles.manager
      )
    },
    isCreateRequestVisible () {
      return this.$store.getters.role === roles.adAgent
    },
    isShowChat () {
      return this.$store.getters.role !== roles.adAgent
    },
    isShowActivity () {
      return this.$store.getters.role !== roles.adAgent
    },
    isAdAgent () {
      return this.$store.getters.role === roles.adAgent
    }
  },
  created () {
    this.connectToWebsocket()
    this.$eventBus.$on(
      'closeActivityView',
      () => (this.isActivityViewVisible = false)
    )
    this.$eventBus.$on(
      'pageHeaderChange',
      newPageHeade => (this.pageHeader = newPageHeade)
    )
    this.$eventBus.$on('closeChat', () => (this.isChatVisible = false))
    this.$eventBus.$on(
      'addUnreadedActivityMessage',
      () => this.countUnreadedActivityMessages++
    )
    this.$eventBus.$on(
      'addUnreadedChatMessage',
      () => this.countUnreadedChatMessages++
    )
  }
}
